var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.71264V12.6493C14 13.396 13.3993 14.0013 12.658 14.0013H3.342C2.60067 14.0013 2 13.396 2 12.6493V4.01997C2 3.2733 2.60067 2.66797 3.342 2.66797H8",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21869 11.4491L7.70602 10.8271C7.82336 10.7978 7.93002 10.7371 8.01602 10.6518L13.6094 5.05847C14.13 4.5378 14.13 3.6938 13.6094 3.17314L13.4947 3.05847C12.974 2.5378 12.13 2.5378 11.6094 3.05847L6.01602 8.6518C5.93069 8.73714 5.87002 8.84447 5.84069 8.9618L5.21869 11.4491",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5533 4.11328L12.5533 6.11328",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69735 10.8299C7.70668 10.7592 7.71868 10.6892 7.71868 10.6159C7.71868 9.69522 6.97268 8.94922 6.05201 8.94922C5.97868 8.94922 5.90868 8.96189 5.83801 8.97055",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.913aa7fa4f66122e4d2620c57bb371f6.svg";
export { ForwardRef as ReactComponent };